import {
  withAdSettings,
  withAnalytics,
  withIdentify,
  withTrackEvent
} from "@outschool/ui-analytics";
import { withTopNoticeContext } from "@outschool/ui-components-website";
import React from "react";

import { withGraphqlContext } from "../providers/GraphqlProvider";
import { withTokenContext } from "../providers/TokenProvider";

const AppStateContext = React.createContext(null);

@withTopNoticeContext
@withTokenContext
@withGraphqlContext
@withAdSettings
@withAnalytics
@withTrackEvent
@withIdentify
export class AppStateProvider extends React.Component {
  constructor(props) {
    super(props);
    const {
      adSettings,
      analytics,
      appState,
      client,
      getAuthData,
      getTokens,
      identify,
      logout,
      resetClientVersion,
      setTimedTopNotice,
      setTokens,
      setTopNotice,
      trackEvent
    } = this.props;
    appState.setAnalytics(analytics, identify, trackEvent, adSettings);
    appState.setLogoutCurrentUser(logout);
    appState.setResetClientVersion(resetClientVersion);
    appState.setApolloClient(client);
    appState.setTopNoticeSetter(setTopNotice);
    appState.setTimedTopNoticeSetter(setTimedTopNotice);
    appState.setAuth({
      getTokens,
      setTokens,
      getAuthData
    });
    appState.initUserData();
    this.state = { appStateWrappedInNewObject: { appState } };
  }

  // This ensures that the context get updated each time appState changes
  changeListener = () => {
    const { appState } = this.props;
    this.setState({ appStateWrappedInNewObject: { appState } });
  };

  componentDidMount() {
    const { appState } = this.props;
    if (appState) {
      appState.addChangeListener(this.changeListener);
    }
  }

  componentWillUnmount() {
    const { appState } = this.props;
    if (appState) {
      appState.removeChangeListener(this.changeListener);
    }
  }

  render() {
    const { children } = this.props;
    const { appStateWrappedInNewObject } = this.state;
    return (
      <AppStateContext.Provider value={appStateWrappedInNewObject}>
        {children}
      </AppStateContext.Provider>
    );
  }
}

export function withAppState(DecoratedComponent) {
  const displayName = DecoratedComponent.displayName || "Component";

  // TODO: Use React.forwardRef
  return class AppStateWrapper extends React.Component {
    static displayName = `AppStateWrapper(${displayName})`;

    render() {
      return (
        <AppStateContext.Consumer>
          {appStateWrappedInNewObject => (
            <DecoratedComponent
              appState={appStateWrappedInNewObject.appState}
              {...this.props}
            />
          )}
        </AppStateContext.Consumer>
      );
    }
  };
}

export function useAppState() {
  const appStateWrappedInNewObject = React.useContext(AppStateContext);
  return appStateWrappedInNewObject.appState;
}
